
























































import { Component, Mixins, Prop } from "vue-property-decorator";
import ExpansionPanel from "../ui/ExpansionPanel.vue";
import MonthPicker from "../ui/MonthPicker.vue";
import { ReportsModule } from "@/store/reports.module";
import FormValidator from "@/mixins/FormValidator";
import { ReportAction } from "~/services/report";
import moment from "moment";
import { AuthModule } from "@/store/auth.module";

@Component({
  components: { ExpansionPanel, MonthPicker },
})
export default class SingleParamReport extends Mixins(FormValidator) {
  @Prop()
  readonly title: string;
  @Prop({ default: false })
  readonly isDefault: boolean;
  @Prop({ required: true })
  readonly path: string;
  @Prop({ required: false, default: false })
  readonly is402: boolean;
  @Prop({ required: false, default: false })
  readonly is470: boolean;

  from = "";
  to = "";
  max = "";
  // min = ???  минимальный период формирования не указан в эпике. Уточнить у Олеси.

  formRef = "form";

  mounted() {
    if (this.is402) this.from = "2021-01-01";
    this.to = moment().format("YYYY-MM");
    this.max = moment().format("YYYY-MM-DD");
  }

  get user() {
    return AuthModule.user as IUser;
  }

  async generate(action: ReportAction) {
    if (!this.validateForm()) return;
    await ReportsModule.generateReport({
      action: action,
      path: this.path,
      type: "pdf",
      filename: this.title,
      query: this.is470
        ? {
            Params: JSON.stringify({
              contract_rid: this.$route.params.id,
              year: moment(this.to).year(),
              month: moment(this.to).month() + 1,
            }),
          }
        : this.is402
        ? {
            iContractRid: this.$route.params.id,
            dDateBegin: this.to.replace("-", "") + "01",
            executor: this.user.iin,
          }
        : {
            iContractId: this.$route.params.id,
            dtDate: this.to.replace("-", "") + "01",
          },
    });
  }
}
